export const pick = (object = {}, ...fields) => {
  const keys = Object.keys(object);

  return keys.filter((key) => fields.includes(key));
};
